import { ArrowIcon } from "components/common/Icons/ArrowIcon";
import { Popup } from "components/common/Popup/Popup";
import { useFont } from "./useFont";
import { FontList } from "./FontList/FontList";
import { useFindTextBox } from "../useFindTextBox";

interface FontProps {
    textBoxId: string;
}

export const Font = ({ textBoxId }: FontProps) => {
    const { close, isOpen, open, loadedFonts, loadMoreGoogleFonts } = useFont();
    const { textBox } = useFindTextBox(textBoxId);
    return (
        <Popup
            isOpen={isOpen}
            close={close}
            content={
                <FontList
                    googleFonts={loadedFonts}
                    loadMoreFonts={loadMoreGoogleFonts}
                    textBox={textBox}
                    onClose={close}
                />
            }
        >
            <button
                onClick={isOpen ? close : open}
                className="flex gap-2 items-center text-sm rounded-xl border border-irGray-200 dark:border-darkSurface-400 hover:border-irGray-400 dark:hover:border-darkSurface-500 py-2 px-2"
            >
                <span
                    className="w-28 pr-1 text-left text-black dark:text-white overflow-hidden text-ellipsis whitespace-nowrap"
                    style={{
                        fontFamily: textBox.fontFamily,
                    }}
                >
                    {textBox.fontFamily}
                </span>
                <ArrowIcon />
            </button>
        </Popup>
    );
};
